import {ChangeDetectionStrategy, Component, effect, inject, signal, viewChild} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {UpdateLicencePlanRequest} from '../../../../../api';
import {LicencePlanStoreService} from '../../services/licence-plan-store.service';
import {ElciaDialog} from '../../../../components/dialog/dialog';
import {Loader} from '../../../../components/loader/loader';
import {LicencePlanGrid} from '../licence-plan-grid/licence-plan-grid';
import {LicencePlanForm} from '../licence-plan-form/licence-plan-form';
import {LicencePlanFormValue} from '../../models/licence-plan-form-value';

@Component({
  selector: 'elcia-licence-plan-home',
  imports: [TranslatePipe, ElciaDialog, Loader, LicencePlanGrid, LicencePlanForm],
  templateUrl: './licence-plan-home.html',
  providers: [LicencePlanStoreService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicencePlanHome {
  protected readonly store = inject(LicencePlanStoreService);

  licencePlanForm = viewChild<LicencePlanForm>(LicencePlanForm);

  isLoading = this.store.isLoading;
  isLoadingSelected = this.store.isLoadingSelected;
  licencePlans = this.store.licencePlans;

  protected isFormDisplayed = signal(false);

  protected onLicencePlanSelect(plan: { id: number }): void {
    this.store.updateLicencePlanMutation.reset();
    this.store.selectedLicencePlanId.set(plan.id);
  }

  protected onDialogSave(): void {
    this.licencePlanForm()?.submit();
  }

  protected closeForm(): void {
    this.isFormDisplayed.set(false);
    this.store.selectedLicencePlanId.set(null);
  }

  protected submit(formValue: LicencePlanFormValue): void {
    if (formValue.id === null) return;
    const body: UpdateLicencePlanRequest = {
      nameFr: formValue.nameFr,
      nameEn: formValue.nameEn,
      nameNl: formValue.nameNl,
      descriptionFr: formValue.descriptionFr ?? undefined,
      descriptionEn: formValue.descriptionEn ?? undefined,
      descriptionNl: formValue.descriptionNl ?? undefined,
      includedFeatureCodes: formValue.includedFeatureCodes,
    };
    this.store.updateLicencePlanMutation.mutate({id: formValue.id, body});
  }

  private readonly openFormOnSelect = effect(() => {
    const selected = this.store.selectedLicencePlan();
    if (!selected) return;
    this.isFormDisplayed.set(true);
  });

  private readonly closeFormOnSuccess = effect(() => {
    if (this.store.updateLicencePlanMutation.isSuccess()) {
      this.closeForm();
    }
  });
}
